import { t } from '~/i18n';

// Device-type values that have a `device.types.*` translation. Values reach here from the
// DeviceType enum and from endpoints that return the hw-refined type as a bare string, so an
// unknown one is possible and must not render as a raw translation key.
const DEVICE_TYPE_KEYS = new Set<string>([
  'watcherr',
  'wall_mounted_distress_button',
  'emergency_button',
  'regular_button',
  'wristband_distress_button',
  'wearable_tag',
  'equipment_tag',
  'beacon',
  'gateway',
  'eview',
  'twig',
  'ixi_lite',
  'ixi_touch',
  'ixi_black',
  'ixi_pro',
  'api_external',
]);

export const deviceTypeLabel = (deviceType: string): string => {
  const key = deviceType.toLowerCase();
  return DEVICE_TYPE_KEYS.has(key) ? t(`device.types.${key}`) : deviceType;
};

/**
 * Product names for a set of types.
 *
 * Deduplicated: a legacy type and its ixi replacement are the same product and translate to the
 * same name, so listing both reads as a mistake ("ixi Lite, ixi Lite").
 */
export const deviceTypeLabels = (deviceTypes: string[]): string[] => [...new Set(deviceTypes.map(deviceTypeLabel))];
